import React, { useState } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import Arrow from "../../assets/images/arrow.png";
import ModelIllustrator from "../../assets/images/modal_illustrator.png";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const Popup = () => {
  // const [show, setShow] = useState(false);
  const [hidden, setHidden] = useState(false);
  const navigate = useNavigate();

  // const handleClose = () => {
  //   setShow(false);
  //   localStorage.setItem("popupClosed", "true");
  // };

  const handleTogglePopup = () => {
    setHidden(!hidden);
  };

  // if (!show) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 10,
        right: 10,
        width: 300,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: 3,
        zIndex: 1300, // above most content but below modals
        transition: "transform 0.5s ease-in-out", // smooth movement
        transform: hidden ? "translateY(85%)" : "translateY(0)", // dynamic position
        animation: "slideIn 0.5s ease-out",
        "@keyframes slideIn": {
          from: {
            transform: "translateY(100%)",
            opacity: 0,
          },
          to: {
            transform: "translateY(0)",
            opacity: 1,
          },
        },
      }}
    >
      <div
        onClick={() => {
          if (hidden) handleTogglePopup();
        }}
       style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
        <Typography variant="h6" fontWeight="bold" sx={{padding: '10px 15px', marginLeft: '20px'}}>
          個別相談のお申込みはこちら! 
        </Typography>
        <IconButton
          // onClick={handleClose}
          onClick={(e) => {
            e.stopPropagation(); // prevent triggering the title click
            handleTogglePopup();
          }}
          sx={{ position: "absolute", top: 5, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </div>

      <Box
        sx={{
          backgroundColor: "#f89b1c",
          color: "white",
          textAlign: "center",
          height: '130px',
          p: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
        オンライン個別相談 <br /> 受付中!
        </Typography>
        <div>
          <img src={ModelIllustrator} alt="Illustration" />
        </div>
      </Box>

      <Box display="flex" justifyContent="center">
        <Button
          variant="contained"
          sx={{
            color: "#fff",
            display: "flex",
            alignItems: "center",
            borderRadius: "30px",
            fontSize: "14px",
            width: "auto",
            height: "50px",
            fontWeight: 700,
            maxHeight: "40px",
            margin: '10px 0',
            fontFamily: "Noto Sans JP, sans-serif",
            padding: "10px 10px 10px 20px",
            background: "linear-gradient(180deg, #F8B62D 0%, #EA5514 100%)",
            transition: "background 0.4s ease, color 0.4s ease",
            "&:hover": {
              background: "black", // Override gradient with black on hover
              color: "white", // Change text color to white on hover
              "& img": {
                transform: "scale(1)", // Zoom in the arrow icon
              },
            },
          }}
          // onClick={() => navigate("/お問い合わせ-2/")}
          onClick={() => {
            navigate("/お問い合わせ-2/"); // Navigate to the new page
          }}
        >
          無料相談
          <Box
            component="img"
            src={Arrow}
            alt="Button image"
            sx={{
              height: "30px",
              width: "30px",
              ml: 3,
              transition: "transform 0.3s ease",
              transform: "scale(0.9)",
            }}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default Popup;
